import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import EnhancedToolbar from '../../widgets/Toolbar';
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import ViewUtils from "./../../ViewUtils";
import AlertItem from "../../widgets/AlertItem";
import { LearnerTVETNCVForm } from '../../etqa/program/registration/LearnerTVETNCVForm';

const TVETNCVRef = React.createRef();
const utils = new ViewUtils();

class AddLearnerTVETNCV extends Component {

    constructor(props) {
        super(props);
        this.state = {
            model: {
                ProviderID: null,
                EmployerID: null,
                SponsorshipID: { Id: 1, Description: "SETA Funded" }
            },
            TVETNCVDetails: {
                TradeProgrammeDescription: "",
                TradeProgrammeCode: ""
            },
            messageStyle: "message",
            id: null,
            showTable: true,
            CurrentProgramme: this.props.location.state.LearnerTVETNCVID,
            CreateNewFlag: this.props.location.state.hideFields,
            Learner: this.props.location.state.LearnerID,
            IsExternalRole: false
        };

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: '', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'save', label: '', tooltip: 'Save', icon: 'SaveIcon', disabled: (this.props.location.state.viewOnly) },
                        { id: 'documents', label: 'DOCUMENTS', tooltip: 'Documents', disabled: (this.props.location.state.hideFields), visible: !(this.props.location.state.hideFields) }
                    ]
                }
            ]
        }
    }

    componentDidMount() {
        if (utils.isNull(this.props.location.state.LearnerTVETNCVID) || this.props.location.state.LearnerTVETNCVID === 0)
        {
            this.defaultSponsorship()
        }
    }

    handleFormValueChange = (values) => {
        if (!utils.isNull(values)) {

            this.setState({
                TVETNCVSetupDetails: {
                    TradeProgrammeCode: values.TradeID,
                    TradeProgrammeDescription: values.TradeTitle
                },
                Learner: this.props.location.state.LearnerID
            });

            let newValues = null;
            if (!utils.isNull(values)) {
                newValues = { ...values };
            }
            if (!utils.isNull(newValues)) {
                if (JSON.stringify(this.state.model) !== JSON.stringify(newValues)) {
                    this.setState({
                        model: newValues,
                    });
                }
            }

            this.ECCheck(values);
        }
    }

    ECCheck(values) {
        if (!utils.isNull(values)) {
            if (!utils.isNull(values.LeadEmployerID)) {
                let url = "api/sims/learner/EmployerContactCheck?EmployerID=" + values.LeadEmployerID.Id;
                utils.invokeUrl(url, (response) => {
                    if (response.Result != "") {
                        this.setState({
                            message: response.Result,
                            messageStyle: "ERROR",
                        })
                    }
                },
                    null,
                    {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer " + localStorage.getItem("token")
                        }
                    }
                )
            }
        }
    }

    onChangeProviderIDHandler = (form, id, event) => {
        let newModel = { ...form.values }
        newModel.ProviderContactID = null;
        this.setState({ model: newModel, clearOptions: true })
    }

    onChangeEmployerIDHandler = (form, id, event) => {
        let newModel = { ...form.values }
        newModel.EmployerContactID = null;
        this.setState({ model: newModel, clearOptions: true })
    }

    clearOptionsHandler = () => {
        this.setState({ clearOptions: false });
    }


    handleToolbarButtonClick(buttonId) {
        if ("save" === buttonId) {
            this.save();
        } else if ("close" === buttonId) {
            this.closeView();
        } else if ("documents" === buttonId) {
            this.props.history.push({
                pathname: '/learnerTVETNCVDocuments',
                state: {
                    LearnerID: this.props.location.state.LearnerID,
                    LearnerTVETNCVID: this.props.location.state.LearnerTVETNCVID,
                    hideFields: false,
                    learnerNames: this.props.location.state.learnerNames,
                    permissions: this.props.location.state.permissions,
                    viewOnly: this.props.location.state.viewOnly
                }
            });
        }
    }

    successCallback = (response) => {
        if (response.MessageType === "SUCCESS") {
            this.setState({
                showTable: false
            }, () => {
                this.setState({
                    showTable: true,
                    message: response.Message,
                    messageStyle: response.MessageType,
                    CurrentProgramme: response.EntityId,
                    CreateNewFlag: false
                })
            });
        }
        else {
            this.setState({
                message: response.Message, messageStyle: response.MessageType
            });
        }
    }

    defaultSponsorship = () => {
        if (utils.getCurrentRole() === "Provider" || utils.getCurrentRole() === "AET Agent" || utils.getCurrentRole() === "Agent") {
            this.setState({
                model: {
                    SponsorshipID: { Id: 2, Description: "Industry Funded" }
                },
                IsExternalRole: true
            })
        }
    }

    save() {
        let formValue = TVETNCVRef.current.getValue();
        if (formValue !== null && typeof formValue !== "undefined") {
            formValue.id = this.props.location.state.LearnerID;
            let input = JSON.stringify(formValue);

            utils.invokeUrl("api/sims/learnerTVETNCV/LinkLearnerTVETNCV", (response) => {
                this.successCallback(response);
            }, () => { alert(utils.SYSTEM_ERROR_MESSAGE) }, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                body: input
            });
        }
    }

    closeView() {
        this.props.history.push({
            pathname: '/LearnerTVETNCVSearch',
            state: {
                learnerID: this.props.location.state.LearnerID,
                learnerNames: this.props.location.state.learnerNames
            }
        });
    }

    render() {
        return (
            <ViewContainer topPadding="0" title="">
                <p className="breadcrumbs">
                    {
                        (this.props.location.state.hideFields) ?
                            `Learner > Link New TVET NCV Support > ${this.props.location.state.learnerNames}`
                            :
                            `Learner > Update TVET NCV Support > ${this.props.location.state.learnerNames}`
                    }
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                <table width="100%">
                    <tbody>
                        <tr>
                            <td>
                                <EnhancedToolbar highlight={false}
                                    title=""
                                    buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                                    config={this.toolbarConfig} />
                            </td>
                        </tr>
                        <tr>
                            <td className="formContainer">
                                <div style={{ height: "65%", maxHeight: "80vh" }}>
                                    {this.state.showTable === true && (
                                        <LearnerTVETNCVForm ref={TVETNCVRef}
                                            viewRef={this}
                                            id={this.state.CurrentProgramme}
                                            hideFields={this.state.CreateNewFlag}
                                            editPermission={this.props.location.state.permissions}
                                            viewOnly={this.props.location.state.viewOnly}
                                            lid={this.props.location.state.LearnerID}
                                            valueChangeHandler={(values) => this.handleFormValueChange(values)}
                                            model={this.state.model}
                                            data={this.state.model}
                                            onChangeProviderIDHandler={this.onChangeProviderIDHandler}
                                            onChangeEmployerIDHandler={this.onChangeEmployerIDHandler}
                                            IsExternalRole={this.state.IsExternalRole} />
                                    )}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ViewContainer>
        );
    }
}

export default withRouter(AddLearnerTVETNCV);
